import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class ComissaoVendasPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.setState({
                listaRegistros: this.props.listaRegistros,
                carregando: false,
            });
            // this.getListaRegistros();
        }
    }

    // getListaRegistros = () => {
    //     this.setState({ carregando: true, listaRegistros: [] });

    //     const { buscaDataIni, buscaDataFim, buscaPessoa } = this.props.filtros;

    //     if ((buscaDataIni) && (buscaDataFim)) {

    //         let dataIni = '';
    //         if ((buscaDataIni) && (buscaDataIni !== undefined)) {
    //             dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    //         }
    //         let dataFim = '';
    //         if ((buscaDataFim) && (buscaDataFim !== undefined)) {
    //             dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    //         }

    //         axios
    //             .get('/vendas/listaCarteiraCliente', {
    //                 params: {
    //                     print: true,
    //                     pessoa: buscaPessoa.key,
    //                     dataIni,
    //                     dataFim,
    //                 }
    //             })
    //             .then(response => {
    //                 const { data } = response;
    //                 this.setState({
    //                     listaRegistros: data.dados,
    //                     carregando: false,
    //                 });
    //             })
    //             .catch(erro => {
    //                 console.warn(erro);
    //                 this.setState({
    //                     carregando: false,
    //                 });
    //             });
    //     } else {
    //         this.setState({
    //             listaRegistros: [],
    //             carregando: false,
    //         });
    //     }

    // };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderValorComissao = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(registro.vlrTotal * (registro.ue_perc_comissao / 100))).format('0,000.00')} </span>
        );
    };


    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Comissões dos Vendedores
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Período: </span>
                                <span>{this.props.periodo}</span>

                                {/* {this.props.pessoa.key ? (
                                    <div>
                                        <span style={{ fontWeight: "bold" }}>Cliente: </span>
                                        <span>{this.props.pessoa.label}</span>
                                    </div>
                                ) : null} */}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Total Comissões: </span>
                                <span>R$ {this.renderValor(this.props.totalComissoes)}</span>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.usu_idf)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="usu_nome"
                                    dataIndex="usu_nome"
                                    title="Nome Vendedor"
                                    width={200}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="ue_perc_comissao"
                                    dataIndex="ue_perc_comissao"
                                    title="% Comissão"
                                    render={this.renderValor}
                                    width={80}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="vlrTotal"
                                    dataIndex="vlrTotal"
                                    title="Valor Total"
                                    render={this.renderValor}
                                    width={80}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key=""
                                    dataIndex=""
                                    title="Valor Comissão"
                                    render={this.renderValorComissao}
                                    width={80}
                                    align="right"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default ComissaoVendasPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/ComissaoVendasPrintModal.js